import { render, staticRenderFns } from "./Buckets.vue?vue&type=template&id=76861768&scoped=true&"
import script from "./Buckets.vue?vue&type=script&lang=js&"
export * from "./Buckets.vue?vue&type=script&lang=js&"
import style0 from "./Buckets.vue?vue&type=style&index=0&id=76861768&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76861768",
  null
  
)

export default component.exports